import Vue from "vue";

import ModuleNewsletterModelProducts from "@DataWeb/Scripts/Components/Modules/ModuleNewsletterModelProducts.vue";

export default {
    install: (Vue, options) => {
        // Explorer modules
        Vue.component("app-modulenewslettermodelproducts", ModuleNewsletterModelProducts);
    }
};